<!-- eslint-disable max-len -->
<template>
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M1.08325 1.5H15.2499C15.2499 1.5 16.9166 2.33333 16.9166 4.41667C16.9166 6.5 15.2499 7.33333 15.2499 7.33333H1.08325C1.08325 7.33333 2.74992 6.5 2.74992 4.41667C2.74992 2.33333 1.08325 1.5 1.08325 1.5ZM16.9166 10.6667H2.74992C2.74992 10.6667 1.08325 11.5 1.08325 13.5833C1.08325 15.6667 2.74992 16.5 2.74992 16.5H16.9166C16.9166 16.5 15.2499 15.6667 15.2499 13.5833C15.2499 11.5 16.9166 10.6667 16.9166 10.6667Z" stroke="#334D6E" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>
<script>
export default {
  name: 'creator',
};
</script>
